import React from 'react';
import { Check } from 'lucide-react';
import type { PermissionToggleProps } from '../../../../../types/groupModulePermissions';

const PermissionToggle: React.FC<PermissionToggleProps> = ({
  checked,
  onChange,
  disabled = false,
  className = ''
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div 
      className={`permission-toggle ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''} ${className}`}
      onClick={handleClick}
      role="switch"
      aria-checked={checked}
      tabIndex={disabled ? -1 : 0}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
          e.preventDefault();
          onChange(!checked);
        }
      }}
    >
      <div className="permission-toggle-track">
        <div className="permission-toggle-thumb">
          {checked && <Check size={12} className="permission-toggle-icon" />}
        </div>
      </div>
    </div>
  );
};

export default PermissionToggle;